<template>
  <div>
    <label :for="id">{{ name }}</label>
    <div class="radioButton">
      <label v-for="option in options" :key="option.value" class="radio-inline">
        <input type="radio" :name="id" :value="option.value" :checked="option.checked" @change="onChange">
        {{ option.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  components: {},
  props: {
    id: String,
    name: String,
    options: Array
  },
  data: () => ({}),
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss">
    @import "./radio-button";
</style>



// WEBPACK FOOTER //
// src/components/Form/RadioButton/radio-button.vue